import {Component, OnInit} from '@angular/core';
import {ProductService} from '../../../shared/services/product.service';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AlertService} from '../../../shared/services/alert.service';
import {AppointmentService} from '../../../shared/services/appointment.service';
import {DoctorService} from '../../../shared/services/doctor.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StorageService} from '../../../shared/services/storage.service';
import {BlogService} from "../../../shared/services/blog.service";
import {HttpClient} from '@angular/common/http';
import {YoutubeService} from "../../../shared/services/youtube.service";
import {GlobalService} from "../../../shared/services/global.service";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
    appointmentForm: FormGroup;
    OtpForm: FormGroup;
    public loginForm: FormGroup;
    public passwordTextType: boolean;
    id: any;
    data: any;
    submitted: any = false;
    submitting: any = false;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    products: any = [];
    medicinalKits: any = [];
    user: any;
    blogList: any;
    decodedOtp: any;
    appointment: any;
    owlCarouselOptions = {
        items: 3,
        responsive: {
            0: {items: 1},
            768: {items: 2},
            1200: {items: 3}
        },
        autoplay: true,          // Enable autoplay
        autoplayTimeout: 3000,
        loop: true
    };
    doctors = [
        {
            name: 'Dr. Yogesh',
            specialization: 'Skin Specialist',
            imageUrl: 'assets/img/Doctorimage/dr-yogesh.webp',
            profileLink: '/doctor-details/dr-yogesh'
        },
        {
            name: 'Dr. Teena Somra',
            specialization: 'Gaynecologist',
            imageUrl: 'assets/img/Doctorimage/dr-teena.webp',
            profileLink: '/doctor-details/dr-teena'
        },
        {
            name: 'Dr. Vishwa Deep Biswas',
            specialization: 'Diabetes Expert',
            imageUrl: 'assets/img/Doctorimage/dr-vishwa.webp',
            profileLink: '/doctor-details/dr-vishwa-deep'
        },
        {
            name: 'Dr. Sonu',
            specialization: 'Child Specialist',
            imageUrl: 'assets/img/Doctorimage/dr-sonu.webp',
            profileLink: '/doctor-details/dr-sonu'
        },
        {
            name: 'Dr. Akshata',
            specialization: 'E.N.T Specialist',
            imageUrl: 'assets/img/Doctorimage/dr-akshata.webp',
            profileLink: '/doctor-details/dr-akshata'
        },
        {
            name: 'Dr. Jagjeet',
            specialization: 'Skin Specialist',
            imageUrl: 'assets/img/Doctorimage/dr-jagjeet.webp',
            profileLink: '/doctor-details/dr-jagjeet'
        },
        {
            name: 'Dr. Vikas Meena',
            specialization: 'General Physcian',
            imageUrl: 'assets/img/Doctorimage/dr-vikas-meena.webp',
            profileLink: '/doctor-details/dr-vikas-meena'
        },

        {
            name: 'Dr. Akansha',
            specialization: 'General Physcian',
            imageUrl: 'assets/img/Doctorimage/dr-akansha.webp',
            profileLink: '/doctor-details/dr-akansha'
        },
        {
            name: 'Dr. Anup',
            specialization: 'Surgeon',
            imageUrl: 'assets/img/Doctorimage/dr-anup.webp',
            profileLink: '/doctor-details/dr-anup'
        },
        {
            name: 'Dr. Ashwani',
            specialization: 'General Physcian',
            imageUrl: 'assets/img/Doctorimage/dr-ashwani.webp',
            profileLink: '/doctor-details/dr-ashwani'
        },
        {
            name: 'Dr. Divya Jain',
            specialization: 'General Physcian',
            imageUrl: 'assets/img/Doctorimage/dr-divya-jain.webp',
            profileLink: '/doctor-details/dr-divya-jain'
        },
        {
            name: 'Dr. Garima',
            specialization: 'Medicine',
            imageUrl: 'assets/img/Doctorimage/dr-garima.webp',
            profileLink: '/doctor-details/dr-garima'
        },
        {
            name: 'Dr. Pradeep',
            specialization: 'General Physcian',
            imageUrl: 'assets/img/Doctorimage/dr-pradeep.webp',
            profileLink: '/doctor-details/dr-pradeep'
        },
        {
            name: 'Dr. Uma Saini',
            specialization: 'General Physcian',
            imageUrl: 'assets/img/Doctorimage/dr-uma-saini.webp',
            profileLink: '/doctor-details/dr-uma-saini'
        },
        {
            name: 'Dr. Alok',
            specialization: 'Lifestyle Expert',
            imageUrl: 'assets/img/Doctorimage/dr-alok2.webp',
            profileLink: '/doctor-details/dr-alok'
        },

        // Add other doctor objects similarly...
    ];

    constructor(private productService: ProductService,
                private activatedRoute: ActivatedRoute,
                private alertService: AlertService,
                private appointmentService: AppointmentService,
                private fb: FormBuilder,
                private doctorService: DoctorService,
                public modalService: NgbModal,
                public router: Router,
                private blogServices: BlogService,
                private http: HttpClient,
                private youtubeService: YoutubeService,
                private globalService: GlobalService,
    ) {
        this.user = StorageService.getItem('self');

    }


    ngOnInit(): void {
        this.refresh();
        // this.getDoctors();
    }


    refresh() {
        this.appointmentForm = this.fb.group({
            name: ['', Validators.required],
            contact: ['', Validators.required],
            symptoms: ['', Validators.required],
            age: ['', Validators.required],
            gender: ['', Validators.required],
        });
        this.OtpForm = this.fb.group({
            otp: ['', Validators.required],
        });
        this.loginForm = this.fb.group({
            'username': ['', Validators.required],
            'password': ['', Validators.required]
        });
        // this.getYoutubeVideo();
        this.getMedicinalKits();
        this.getBlogs();
        this.getProduct();
        // this.getYoutubeVideo();
    }


    // getYoutubeVideo() {
    //     this.youtubeService.getYoutubeVideos().subscribe((data: any) => {
    //         this.youtubeVideos = data['items']?.id?.videoId;
    //     })
    // }

    getBlogs() {
        // @ts-ignore
        this.blogServices.get({'page': 1, 'per_page': 3}).subscribe((data: any) => {
            this.blogList = data['data'];
        })
    }

    getProduct() {
        this.submitting = true;
        this.products = [];
        this.productService.get({'page': 1, 'per_page': 12, 'category_id': 1}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.products = data['data'];
                if (this.products && this.products.length > 0) {
                    this.products.forEach(product => {
                        if (product && product['discounted_price'] && product['igst']) {
                            product['total_price'] = Math.round(parseFloat(product['discounted_price']) + ((parseFloat(product['discounted_price']) * parseFloat(product['igst'])) / 100))
                        }
                    });
                }
            } else {
                this.products = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    getMedicinalKits() {
        this.submitting = true;
        this.medicinalKits = [];
        this.productService.get({'page': 1, 'per_page': 6, 'category_id': 2}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.medicinalKits = data['data'];
                if (this.medicinalKits && this.medicinalKits.length > 0) {
                    this.medicinalKits.forEach(medicinalKit => {
                        if (medicinalKit && medicinalKit['discounted_price'] && medicinalKit['igst']) {
                            medicinalKit['total_price'] = Math.round(parseFloat(medicinalKit['discounted_price']) + ((parseFloat(medicinalKit['discounted_price']) * parseFloat(medicinalKit['igst'])) / 100));
                        }
                    });
                }
            } else {
                this.medicinalKits = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    // getDoctors() {
    //     this.doctorService.get().subscribe(data => {
    //         if (data && data['data'].length > 0) {
    //             this.doctors = data['data'];
    //         }
    //     });
    // }

    get f() {
        return this.loginForm.controls;
    }

    submit(content3) {
        // if (!this.user || !this.user.user_id) {
        //     this.router.navigate(['/']).then(() => {
        //         window.open('/login');
        //     });
        // }
        this.submitted = true;
        if (!this.appointmentForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.appointmentForm.value && this.appointmentForm.value.name) ? this.appointmentForm.value.name : '',
                'contact': (this.appointmentForm.value && this.appointmentForm.value.contact) ? this.appointmentForm.value.contact : '',
                'symptoms': (this.appointmentForm.value && this.appointmentForm.value.symptoms) ? this.appointmentForm.value.symptoms : '',
                'age': (this.appointmentForm.value && this.appointmentForm.value.age) ? this.appointmentForm.value.age : '',
                'gender': (this.appointmentForm.value && this.appointmentForm.value.gender) ? this.appointmentForm.value.gender : '',
                'mode': 'ONLINE'
            };
            this.appointmentService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.appointment = data;
                    this.decodedOtp = (this.appointment && this.appointment['decoded_otp']) ? this.appointment['decoded_otp'] : '';
                    // this.resendOTPTimer();
                    // this.modalService.open(content, {'size': 'md'});
                    this.modalService.open(content3, {'backdrop': 'static', 'keyboard': false});
                    /*this.router.navigateByUrl('login');*/
                    this.appointmentForm.patchValue({
                        'name': '',
                        'contact': '',
                        'symptoms': '',
                        'age': '',
                        'gender': ''
                    });
                    // this.appointmentForm.reset();
                }
            }, error => {
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].symptoms && error['error']['errors'].symptoms.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].symptoms[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                    if (error['error']['errors'].gender && error['error']['errors'].gender.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].gender[0]);
                        return;
                    }
                    if (error['error']['errors'].mode && error['error']['errors'].mode.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].mode[0]);
                        return;
                    }
                }
            });
        }
    }


    submitOtp(content2) {
        this.submitted = true;
        if (!this.OtpForm.valid) {
            return;
        }
        let params = {
            'contact': (this.appointment && this.appointment['contact']) ? this.appointment['contact'] : '',
            'otp': (this.OtpForm.value && this.OtpForm.value.otp) ? this.OtpForm.value.otp : '',
            'decoded_otp': this.decodedOtp
        };
        this.appointmentService.verifyOtp(params).subscribe(data => {
            if (data) {
                this.globalService.setAccessToken(data.token);
                this.globalService.setSelf({
                    'name': data.name,
                    'user_id': data.id,
                    'username': data.username,
                    'email': data.email,
                    'contact': data.contact,
                    'user_type': data.user_type
                });
                this.decodedOtp = undefined;
                this.submitting = false;
                this.submitted = false;
                this.refresh();
                this.modalService.dismissAll('');
                this.router.navigate(['/']).then(() => {
                    window.location.reload();
                });
            }
        }, error => {
            this.submitting = false;
            this.submitted = false;
            if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                if (error['error']['errors'].otp && error['error']['errors'].otp.length > 0) {
                    this.alertService.showErrors(error['error']['errors'].otp[0]);
                    return;
                }
            }
        });
    }

    login() {
        this.router.navigateByUrl('login');
    }


    goTo(url) {
        this.router.navigateByUrl(url);
    }
}
